// @flow

/**
 * Base unit.
 */

const baseUnit = 8;

/**
 * Export `columns`.
 */

export function columns(numberOfColumns: number): number {
  return 100 / 12 * numberOfColumns;
}

/**
 * Export `units`.
 */

export function units(number: number): string {
  return `${number * baseUnit}px`;
}



// WEBPACK FOOTER //
// ../src/client/styles/units.js